import { useAuth } from './use-auth';

export const useShouldCompleteProfile = () => {
  const { profile, isUSCAccount } = useAuth();
  if (!profile || isUSCAccount) {
    return false;
  }

  if (
    !profile.firstName ||
    !profile.lastName ||
    !profile.phoneNumber ||
    !profile.street ||
    !profile.country ||
    !profile.gender ||
    !profile.postcode ||
    !profile.city ||
    !profile.language ||
    !profile.dateOfBirth
  ) {
    return true;
  }
  return false;
};
